export default __webpack_public_path__ + "static/media/6.7f2633e9.jpg";